import React, { Fragment } from 'react';
import CoverImage from '../components/CoverImage';
import { Content } from './TextSlide';
import styled, { css } from 'styled-components';
import responsive, { breakpoint, isSafariLike } from '../utils/responsive';
import { Paragraph } from './typography';
import { TrianglesTopLeft, TrianglesTopRight } from './Triangles';
import foodCover from '../assets/images/food/breakfast-46.jpg';
import Header from './Header';
import PlainLink from './NavLink';
import { navigate } from '@reach/router';
import { LanguageContext } from './i18n/LanguageContext';
import { AbsoluteBottom } from './slideshow/Slideshow';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background: ${props => props.theme.backgroundColor.toHex()};
`;

const Section = ({ background, children, decorator, id, imgStyle, BottomWidget }) => (
  <Container id={id}>
    <CoverImage style={imgStyle} src={background}>
      {decorator}
      {BottomWidget && (
        <AbsoluteBottom>
          <BottomWidget />
        </AbsoluteBottom>
      )}
    </CoverImage>
    {children}
  </Container>
);

export const SplitScreen = styled.div`
  display: flex;
  flex: 1 0 auto;
  max-width: 100vw;
  ${responsive.sm.andSmaller`
    flex-wrap: wrap;
  `}

  > div {
    :first-child {
      border-right: 1px solid white;
    }

    :last-child {
      border-left: 1px solid white;
    }
  }
  > img {
    :first-child {
      border-right: 1px solid white;
    }

    :last-child {
      border-left: 1px solid white;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  object-fit: contain;
  background-position: center center;
`;

const TContainer = styled.div`
  min-height: 100vh;
  position: relative;

  > img {
    width: 20%;
    z-index: 0;
    opacity: 0.6;
  }

  .restaurant-content {
    ${responsive.md.andSmaller`
      padding: 0em 2em 1em 2em;
  `}
  }
`;

export const Abstract = styled(Paragraph)`
  text-align: center;
  font-style: italic;
  opacity: 0.8;
  padding: 7em 10em 0 10em;

  ${responsive.md.andSmaller`
    padding: 2em;
    
    & > img {
      width: 40%;
    }
  `}
`;

export const Logo = styled(PlainLink)`
  width: 8em;
  height: 8em;
  background: url(${props => props.src});
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  :hover {
    transform: scale(1.05);
  }
  :active {
    transform: scale(0.95);
  }
  transition: transform 0.1s ease-in;
`;

const Restaurant = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
`;

const TeaserLink = styled(PlainLink)`
  font-weight: 600;
  font-size: 1.1em;
  ${responsive.md.andSmaller`
    align-self: flex-end;
  `}

  ${responsive.sm.andSmaller`
    font-size: 0.8em;
  `}
`;

const TextTeaser = ({ logo, text, linkTo, label }) => (
  <Content className={'restaurant-content'}>
    <Logo src={logo} to={linkTo} />
    <Paragraph>{text}</Paragraph>
    <TeaserLink to={linkTo}>{`${label} `}&rarr;</TeaserLink>
  </Content>
);

const SplitImage = styled.img`
  position: relative;
  background-color: rgba(0, 0, 0, 1);
  cursor: pointer;
  transition: opacity 0.2s ease;
  :hover {
    opacity: 0.8;
  }
  width: 50%;
  ${isSafariLike() &&
    css`
      max-height: 60vh;
      object-fit: cover;
    `}
`;

const RestaurantContentWeb = ({ common, left, right, labels }) => (
  <Fragment>
    <SplitScreen>
      <SplitImage src={left.cover} alt={left.title} onClick={() => navigate(left.linkTo)} />
      <SplitImage src={left.cover1} alt={left.title} onClick={() => navigate(left.linkTo)} />
      {/*<SplitImage src={right.cover} alt={right.title} onClick={() => navigate(right.linkTo)} />*/}
    </SplitScreen>
    <TContainer>
      <Abstract>{common.body}</Abstract>
      <SplitScreen>
        <TextTeaser linkTo={left.linkTo} logo={left.logo} text={left.body} label={labels.readMore} />
        {/*<TextTeaser linkTo={right.linkTo} logo={right.logo} text={right.body} label={labels.readMore} />*/}
      </SplitScreen>
      <TrianglesTopRight />
      <TrianglesTopLeft />
    </TContainer>
  </Fragment>
);

const RestaurantContentMobile = ({ common, left, right, labels }) => (
  <Fragment>
    <Abstract>{common.body}</Abstract>
    <SplitImage style={{ width: '100%' }} src={left.cover} alt={left.title} onClick={() => navigate(left.linkTo)} />
    <TextTeaser linkTo={left.linkTo} logo={left.logo} text={left.body} label={labels.readMore} />
    {/*<SplitImage style={{ width: '100%' }} src={right.cover} alt={right.title} onClick={() => navigate(right.linkTo)} />*/}
    {/*<TextTeaser linkTo={right.linkTo} logo={right.logo} text={right.body} label={labels.readMore} />*/}
  </Fragment>
);

const RestaurantContent = window.innerWidth < breakpoint.md ? RestaurantContentMobile : RestaurantContentWeb;

export const RestaurantSection = ({ common, left, right }) => (
  <LanguageContext.Consumer>
    {({ content }) => (
      <Restaurant>
        <Section background={foodCover} decorator={<Header subtitle={content.general.restaurantLabel} />} />
        <RestaurantContent common={common} left={left} right={right} labels={content.general} />
      </Restaurant>
    )}
  </LanguageContext.Consumer>
);

export default Section;
